import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getClassName } from '../../../utils/InputValidation';
import Label from '../Label/Label';
import '../Fields.scss';

const renderInput = ({
  optional,
  autoFocus,
  placeholder,
  input,
  name,
  type,
  label,
  meta: { touched, invalid, visited, },
  customClass,
}) => {
  const inputWrapperClasses = classNames('input-wrapper', customClass);
  return (
    <div className={inputWrapperClasses}>
      {label && <Label optional={optional} name={name} label={label} />}
      <input
        {...input}
        type={type}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className={getClassName(touched, invalid, visited)}
      />
      <style jsx="true">{`
        .input__wrapper {
          margin-bottom: 20px;
        }
        .input__help-text {
          font-style: italic;
        }
      `}</style>
    </div>
  );
};

renderInput.propTypes = {
  input: PropTypes.object.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  optional: PropTypes.bool,
  placeholder: PropTypes.string,
  hideMessages: PropTypes.bool,
  customClass: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ]),
  }).isRequired,
};

renderInput.defaultProps = {
  label: '',
  name: '',
  autoFocus: false,
  hideMessages: false,
  optional: false,
  placeholder: '',
  type: 'text',
};

export default renderInput;
